import Vue from 'vue'
import App from './App.vue'
import VueGtag from "vue-gtag";
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

Vue.use(VueGtag, {
  config: { id: "G-RZWX5MBQKN" }
});


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
